import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import AdminCustomizer from "./AdminCustomizer";
import AdminEditor from "./AdminEditor";

export default function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route element={<AdminLayout />}>
        <Route index element={<AdminCustomizer />} />
        <Route path="json" element={<AdminEditor />} />
      </Route>
    </Routes>
  );
}
